module.exports = __webpack_public_path__ + "components/flag/static/square/ps-88e8c38412e6d4b45bb41fd39dc020f6.svg";